import moment from 'moment'

export const formatarCompetencia = (data) => {
  if (data === null || data === undefined) return null

  const dataDaCompetencia = moment(data)
  return dataDaCompetencia.isValid() ? dataDaCompetencia.format('YYYY-MM') : null
}

export const definirDataParaConsultarJornadasComProblemas = (dataHoje, dataInicialComponente, dataFinalComponente) => {
  const copiaDataInicioComponente = moment(dataInicialComponente).clone()
  const copiaDataFimComponente = moment(dataFinalComponente).clone()
  const copiaDataHoje = moment(dataHoje).clone()
  const diaDataHojeEhIgualADiaDataInicialDoComponente = moment(copiaDataHoje).isSame(copiaDataInicioComponente, 'days')
  const mesDataHojeEhIgualAoMesDataFinalDoComponente = moment(copiaDataHoje).isSame(dataFinalComponente, 'month')
  const dataHojeEhDiaUm = copiaDataHoje.date() === 1

  let dataInicio
  let dataFim

  if (diaDataHojeEhIgualADiaDataInicialDoComponente) {
    dataInicio = copiaDataInicioComponente.subtract(1, 'month')
    if (dataHojeEhDiaUm) {
      const fimDoMesAnteriorDeAcordoComADataDeInicio = moment(dataInicio).endOf('month')
      dataFim = fimDoMesAnteriorDeAcordoComADataDeInicio
    } else {
      const fimDoMesAnteriorDeAcordoComADataFinalDoComponente = copiaDataFimComponente.subtract(1, 'month')
      dataFim = fimDoMesAnteriorDeAcordoComADataFinalDoComponente
    }
  } else {
    dataInicio = copiaDataInicioComponente

    if (mesDataHojeEhIgualAoMesDataFinalDoComponente) {
      const diaOntem = dataHoje.subtract(1, 'day')
      dataFim = diaOntem
    } else {
      dataFim = copiaDataFimComponente
    }
  }
  return {dataInicio, dataFim}
}

/**
 * Converte um saldo de banco de horas no formato "HH:MM" ou "-HH:MM" em
 * minutos com sinal. Necessário porque o sinal vale para o saldo inteiro
 * (não só para as horas) — somar "12:30" e "-04:15" exige normalizar ambos.
 */
export const analisarSaldoHorasEmMinutos = (horas) => {
  if (!horas) return 0
  const texto = String(horas).trim()
  const negativo = texto.startsWith('-')
  const [parteHoras = '0', parteMinutos = '0'] = texto.replace('-', '').split(':')
  const minutos = Math.abs(Number(parteHoras)) * 60 + Math.abs(Number(parteMinutos))
  return negativo ? -minutos : minutos
}

/**
 * Formata um total de minutos com sinal no padrão de saldo do Figma: "+0h24".
 */
export const formatarSaldoHoras = (minutos) => {
  const sinal = minutos < 0 ? '-' : '+'
  const total = Math.abs(Math.trunc(minutos))
  const horas = Math.floor(total / 60)
  const restoMinutos = total % 60
  return `${sinal}${horas}h${String(restoMinutos).padStart(2, '0')}`
}
